// services/validators/authService.js

import { login } from '../../utils/session';

export async function loginUsuario({ username, password }) {
  const res = await fetch("https://zafirovalidadores.com.ar/v1/api/login/", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });

  const data = await res.json();

  if (!res.ok) throw new Error(data.error || "Error al iniciar sesión");

  login(data.token); 
  localStorage.setItem("user", JSON.stringify(data.user));

  return data;
}
